import React from "react";

export interface TableColumn {
  header: string;
  render: (item: any) => React.ReactNode;
}

interface TableComponentProps {
  columns: TableColumn[];
  data: any[];
}

const TableComponent: React.FC<TableComponentProps> = ({ columns, data }) => {
  return (
    <table className="metrics-table">
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th key={index}>{column.header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map((column, colIndex) => (
              <td key={colIndex}>{column.render(item)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TableComponent;
